import preorder from './preorder'
import bkacct from './bkacct'
import ledger from './ledger'
import profile from './profile'
import creditdg from './creditdg'
import txntw from './txntw'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    preorder,
    bkacct,
    ledger,
    profile,
    creditdg,
    txntw,
  }
}
